import * as React from "react";
import { ContentProps } from "components/flexComponents/Content/typings";
import { decorateEditorialHtml } from "../../../ContentUtilities";
import { UitkText } from "uitk-react-text";

const CONTENT_ID_COUNT = 3;
export const CardComparisonSectionEditorial = (props: ContentProps) => {
  const flexComponent = props.flexComponent;
  const model = flexComponent && flexComponent.model;
  const items = (model && model.items && model.items.filter((item) => item)) || [];

  if (!model || items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [cardTitle, cardSubTitle, description] = React.useMemo(
    () => items.map((item) => decorateEditorialHtml(item.text)),
    []
  );

  return (
    <div>
      <UitkText align="center" size={700} weight="bold">
        <div dangerouslySetInnerHTML={cardTitle} className="all-t-padding-twelve" />
      </UitkText>
      <UitkText align="center" size={400} weight="bold">
        <div dangerouslySetInnerHTML={cardSubTitle} className="all-t-padding-one" />
      </UitkText>
      <UitkText align="center" size={200}>
        <div dangerouslySetInnerHTML={description} className="all-t-padding-two" />
      </UitkText>
    </div>
  );
};

export default CardComparisonSectionEditorial;
